import { PAYMENT_FIELDS } from '../constants/paymentFields';
import { isDefined } from './helpers';

// Default for Payments
const DICTIONARY = {
  [PAYMENT_FIELDS.customer]: 'payment_customer',
  [PAYMENT_FIELDS.processor]: 'payment_gateway_name',
  [PAYMENT_FIELDS.method]: 'payment_method',
  [PAYMENT_FIELDS.phone]: 'payment_customer_phone',
};

const renameField = (fieldName, sortKeys) => {
  if (isDefined(sortKeys)) {
    return sortKeys[fieldName] ?? fieldName;
  }

  return DICTIONARY[fieldName] ?? fieldName;
};
/**
 * @param {Object.<string, 'asc'|'desc'>} sort
 *
 * @return {Array<{ fieldName: string, order: 'ASC'|'DESC' }>}
 * */
const transformSearchParamsToSort = (sort, sortKeys) =>
  Object.entries(sort).reduce(
    (acc, [fieldName, order]) => [...acc, { fieldName: renameField(fieldName, sortKeys), order: order?.toUpperCase() }],
    []
  );

export { transformSearchParamsToSort };
